import { Info16Regular } from "@fluentui/react-icons";
import styles from "../layouts/EmplyeesListStyles";

interface ReadOnlyInfoBannerProps {
  message: string;
}

const ReadOnlyInfoBanner: React.FC<ReadOnlyInfoBannerProps> = ({ message }) => (
  <div style={styles.readOnlyInfoBanner} role="status">
    <Info16Regular style={styles.readOnlyInfoBannerIcon} aria-hidden />
    <span style={styles.readOnlyInfoBannerText}>{message}</span>
  </div>
);

export default ReadOnlyInfoBanner;
